import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface ImageGalleryProps {
  images: string[];
}

export function ImageGallery({ images }: ImageGalleryProps) {
  const [index, setIndex] = useState(0);

  if (images.length === 0) {
    return null;
  }

  const goTo = (next: number) => {
    setIndex((next + images.length) % images.length);
  };

  return (
    <div className="relative w-full h-48 kiosk:h-[18vw] rounded-xl kiosk:rounded-[1.2vw] overflow-hidden bg-kiosk-accent-soft/15">
      <AnimatePresence mode="wait" initial={false}>
        <motion.img
          key={images[index]}
          src={images[index]}
          alt=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="absolute inset-0 w-full h-full object-contain"
        />
      </AnimatePresence>

      {images.length > 1 && (
        <>
          <button
            type="button"
            onClick={() => goTo(index - 1)}
            aria-label="Előző kép"
            className="absolute left-1.5 kiosk:left-[0.6vw] top-1/2 -translate-y-1/2 w-8 h-8 kiosk:w-[2.2vw] kiosk:h-[2.2vw] rounded-full bg-black/40 text-white flex items-center justify-center text-lg"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={() => goTo(index + 1)}
            aria-label="Következő kép"
            className="absolute right-1.5 kiosk:right-[0.6vw] top-1/2 -translate-y-1/2 w-8 h-8 kiosk:w-[2.2vw] kiosk:h-[2.2vw] rounded-full bg-black/40 text-white flex items-center justify-center text-lg"
          >
            ›
          </button>
          <div className="absolute bottom-1.5 kiosk:bottom-[0.6vw] left-0 right-0 flex justify-center gap-1.5 kiosk:gap-[0.5vw]">
            {images.map((src, i) => (
              <button
                key={src}
                type="button"
                onClick={() => goTo(i)}
                aria-label={`${i + 1}. kép`}
                className={`w-1.5 h-1.5 kiosk:w-[0.5vw] kiosk:h-[0.5vw] rounded-full transition-colors ${
                  i === index ? 'bg-white' : 'bg-white/40'
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
